/**
 * @description Controler/Action String variables
 */
export const USER = 'User';
export const GETLOGINUSER = 'GETLOGINUSER';
export const AUTHENTICATION = 'Authentication';
export const AUTHENTICATE = 'authenticate';
export const IDENTITY = 'identity';
export const PATIENTS = 'patients';
export const PATIENT = 'patient';
export const GENDER = 'genders';
export const COUNTRIES = 'countries';
export const MARITAL_STATUS = 'maritalstatuses';
export const CONNECT_TOKEN = 'connect/token';
export const STATES = 'states';
export const COUNTRY = 'Country';
export const STATE = 'State';
export const NAME_SUFFIXES = 'namesuffixes';
export const NAME_PREFIXES = 'nameprefixes';
export const CHARTS = 'charts';
export const APPOINTMENTS = 'appointments';
export const PROVIDERS = 'providers';
export const ORDERS = 'orders';
export const LABS = 'labs';
export const LAB_RESULTS = 'labresults';
export const LOOKUPS = 'lookups';
export const LOOKUP = 'lookup';
export const MSUBSTITUTIONS = 'msubstitutions';
export const MTAKEN = 'mtaken';
export const SYSTEMS = 'systems';
export const CONSTANTS = 'constants';
export const WAITING_LISTS = 'waitinglist';
export const DOCUMENTS = 'documents';
export const MEDICATIONS = 'medications';
export const CALENDAR_VIEW = 'calender_view';
export const ERX = 'eRx';
export const EPCS = 'epcs';
export const RXORDERS = 'rxorders';
export const NEWRX = 'newrx';
export const CANCELRX = 'cancelrx';
export const REFILL_REQUEST = 'renewalrequest';
export const ALLERGIES = 'allergies';
export const PRESCRIPTIONS = 'prescriptions';
export const MESSAGING = 'messaging';
export const TASKS = 'tasks';
export const REFILLS = 'refills';
export const RX_TRANSMISSION_HISTORIES = 'rxtransmissionhistories';
export const ORDER_NUMBER = 'ordernumber';
export const FACILITIES = 'facilities';
export const TAXONOMIES = 'taxonomies';
export const AUTH = 'administration';
export const ROLES = 'roles';
export const GROUPS = 'groups';
export const USERS = 'users';
export const PERSONAL = 'personal';
export const PROVIDER = 'provider';
export const CONTACT = 'contact';
export const SECURITY = 'security';
export const PASSWORD = 'password';
export const PHARMACIES = 'pharmacies';
export const PHARMACY_TYPES = 'pharmacytypes';
export const NPIREGISTRY = 'npiregisry';
export const ENROLLMENTS = 'enrollments';
export const ERXSERVICES = 'erxservice';
export const REQUESTS = 'requests';
export const APPROVAL = 'approval';
export const ACCEPTANCE = 'acceptance';
export const APPROVALHISTORIES = 'approvalhistories';
export const ACCEPTANCEHISTORIES = 'acceptancehistories';
export const PRACTICES = 'practices';
export const PRESCRIBERDEVICES = 'prescriberdevices';
export const CHANGE_REQUEST = 'changerequest';
export const REFILL_REQUESTS = 'renewalrequest';
export const SIGNATURE = 'signature';
export const RXDENIALREASONS = 'rxdenialreasons';
// export const RXRENEWALRESPONSE = 'renewalresponse';
export const RXCHANGERESPONSE = 'changeresponse';
export const PHARMACYREQUEST = 'pharmacyrequest';
export const MSGTYPE = 'msgtype';
export const MSGREQUESTCODE = 'msgrequestcode';
export const MSGREQUEST_SUBCODE = 'msgrequestsubcode';
export const RXRENEWALRESPONSE = 'renewalresponse';
export const AUDIT = 'audit';
export const EPCSACTIVITYLOGS = 'epcsactivitylogs';
export const SECURITYAUDIT = 'securityaudits';
export const EPCSMSGTYPE = 'epcsmsgtype';
export const NOTIFYPRINT = 'notifyprinting';
export const AUDITACTIONTYPE = 'auditactiontype';
export const AUDITIMPACTDATA = 'auditimpacteddatatype';
export const DOWNLOAD = 'download';
export const VITALSIGNS = 'vitalsigns';
export const PERMISSIONS = 'permissions';
export const VALIDATIONS = 'validations';
export const ADDRESS = 'address';
export const PATIENTCHARTS = 'patientcharts';
export const PRODUCTS = 'products';
export const DRUGSEARCH = 'drugsearch';

const DEMO = {
   BLANK_LINK: '#!',
};

/**
 * @description Mobile Appointment layout Enums
 */
export const MOBILE_APPOINTMENT_LAYOUT = {
   LISTING: 0,
   DAILY: 1,
   MONTHLY: 2,
   WEEKLY: 3,
};

export const fieldLengths = {
   DRUG_NAME_LEN: 105,
   RX_NOTE_LEN: 209,
   RX_SIG_LEN: 224,
   FIRST_NAME: 35,
   MIDDLE_NAME: 35,
   LAST_NAME: 35,
   PRACTISE_NAME: 70,
   EMAIL_ADDRESS: 80,
   MEDICARE_N0: 35,
   MEDICAID_NO: 35,
   DEA_NUMBER: 35,
   SSN: 10,
   SSN_US: 9,
   NPI: 10,
   NADEAN: 35,
   SPI: 13,
   SPECIALTY: 10,
   SUFFIX: 10,
   PREFIX: 10,
   ADDRESS: 40,
   CITY: 35,
   STATE: 2,
   POSTAL_CODE: 9,
   COUNTRY: 2,
   CELL_PHONE: 10,
   EXTENSION: 8,
   HOME_PHONE: 10,
   WORK_PHONE: 10,
   DESCRIPTION: 100,
   PROVIDER_CODE: 10,
   PAGER: 10,
   FAX: 10,
   TAX_ID: 15,
   MEDICARE_GROUP_NO: 10,
   IDP_ID: 80,
   BCBS_PIN: 10,
   LICENCE_NO: 15,
   PASSWORD: 50,
   GROUP_NAME: 25,
   GROUP_DESCRIPTION: 100,
   ROLE_NAME: 25,
   ROLE_DESCRIPTION: 100,
};

export const minFieldLengths = {
   DRUG_NAME_LEN: 105,
   RX_NOTE_LEN: 209,
   RX_SIG_LEN: 224,
   FIRST_NAME: 2,
   MIDDLE_NAME: 1,
   LAST_NAME: 2,
   PRACTISE_NAME: 5,
   EMAIL_ADDRESS: 1,
   MEDICARE_N0: 2,
   MEDICAID_NO: 2,
   DEA_NUMBER: 2,
   SSN: 1,
   SSN_US: 1,
   NPI: 10,
   NADEAN: 2,
   SPI: 2,
   SPECIALTY: 1,
   SUFFIX: 1,
   PREFIX: 1,
   ADDRESS: 1,
   CITY: 1,
   STATE: 2,
   POSTAL_CODE: 5,
   COUNTRY: 1,
   CELL_PHONE: 7,
   EXTENSION: 1,
   HOME_PHONE: 7,
   WORK_PHONE: 7,
   DESCRIPTION: 1,
   PROVIDER_CODE: 3,
   PAGER: 7,
   FAX: 7,
   TAX_ID: 5,
   MEDICARE_GROUP_NO: 5,
   IDP_ID: 5,
   BCBS_PIN: 5,
   LICENCE_NO: 5,
   PASSWORD: 8,
   GROUP_NAME: 2,
   GROUP_DESCRIPTION: 2,
   ROLE_NAME: 2,
   ROLE_DESCRIPTION: 2,
};

export const calendarfilter = [
   { label: 'Today', value: 0 },
   { label: 'This Week', value: 1 },
   { label: 'Next Week', value: 2 },
   { label: 'This Month', value: 3 },
   { label: 'Next Month', value: 4 },
];
export const providerfilter = [
   { label: 'Provider 1', value: 0 },
   { label: 'Provider 2', value: 1 },
   { label: 'Provider 3', value: 2 },
   { label: 'Provider 4', value: 3 },
   { label: 'Provider 5', value: 4 },
];
export const suffixEnum = [
   { label: 'Jr', value: 0 },
   { label: 'Snr', value: 1 },
];
// Self, Spouse, Son, Daughter, Sister, Brother, Mother, Father,....,Other
export const RelationshipListEnum = [
   { label: 'Son', value: 0 },
   { label: 'Daughter', value: 1 },
   { label: 'Sister', value: 2 },
   { label: 'Brother', value: 3 },
   { label: 'Mother', value: 4 },
   { label: 'Father', value: 5 },
];
export const prefixEnum = [
   { label: 'Mr', value: 0 },
   { label: 'Mrs', value: 1 },
   { label: 'Miss', value: 1 },
   { label: 'Madam', value: 1 },
   { label: 'Brother', value: 1 },
   { label: 'Aunty', value: 1 },
];

export const statusEnum = [
   { label: 'Active', value: 0 },
   { label: 'Inactive', value: 1 },
];
export const genderEnum = [
   { label: 'Male', value: 0 },
   { label: 'Female', value: 1 },
   { label: 'Unassigned', value: 2 },
];
export const maritalStatusEnum = [
   { label: 'Married', value: 0 },
   { label: 'Single', value: 1 },
   { label: 'Divorced', value: 2 },
   { label: 'Widow', value: 3 },
   { label: 'Acquintance', value: 4 },
   { label: 'Undecided', value: 5 },
];
export const statesEnum = [
   { label: 'America', value: 'america' },
   { label: 'Germany', value: 'germany' },
   { label: 'USA', value: 'usa' },
];
export const employmentEnum = [
   { label: 'Employed', value: '1' },
   { label: 'Unemployed', value: '0' },
];

export const studentEnum = [
   { label: 'Student', value: '1' },
   { label: 'Teacher', value: '0' },
];

export const countryEnum = [
   { label: 'Nigeria', value: 'Nigeria' },
   { label: 'America', value: 'America' },
];

export default DEMO;

export const accountTypeEnum = {
   provider: 0,
   nonProvider: 1,
};

export const reviewSignoffDummy = [
   {
      Date: 'January 12',
      Provider: 'Dr Festus',
      Name: 'John Doe',
   },
   {
      Date: 'January 12',
      Provider: 'Dr Festus',
      Name: 'John Doe',
   },
   {
      Date: 'January 12',
      Provider: 'Dr Festus',
      Name: 'John Doe',
   },
   {
      Date: 'January 12',
      Provider: 'Dr Festus',
      Name: 'John Doe',
   },
   {
      Date: 'January 12',
      Provider: 'Dr Festus',
      Name: 'John Doe',
   },
   {
      Date: 'January 12',
      Provider: 'Dr Festus',
      Name: 'John Doe',
   },
   {
      Date: 'January 12',
      Provider: 'Dr Festus',
      Name: 'John Doe',
   },
   {
      Date: 'January 12',
      Provider: 'Dr Festus',
      Name: 'John Doe',
   },
   {
      Date: 'January 12',
      Provider: 'Dr Festus',
      Name: 'John Doe',
   },
   {
      Date: 'January 12',
      Provider: 'Dr Festus',
      Name: 'John Doe',
   },
   {
      Date: 'January 12',
      Provider: 'Dr Festus',
      Name: 'John Doe',
   },
];

export const formErrorsValues = {
   FirstName: false,
   LastName: false,
   MiddleName: false,
   Suffix: false,
   Prefix: false,
   SSN: false,
   AccountNumber: false,
   Email: false,
   Gender: false,
   Address: {
      Country: false,
      AddressLine1: false,
      AddressLine2: false,
      City: false,
      State: false,
      ZipCode: false,
   },
   PhoneNumbers: [
      {
         Number: false,
         Qualifier: 1,
      },
      {
         Number: false,
         Qualifier: 2,
      },
      {
         Number: false,
         Qualifier: 3,
      },
   ],
   DateOfBirth: false,
   MaritalStatus: false,
};

export const AuxDownloadOptions = {
   text: 1,
   csv: 2,
   excel: 3,
   doc: 4,
   pdf: 5,
};

export const rxResponseEnums = {
   approve: '1',
   approveWithChanges: '2',
   replace: '3',
   decline: '4',
   denied: '3',
   validated: '4',
   declineNewToFollow: '5',
};

export const rxResponseTransEnums = {
   A: '1',
   AC: '2',
   R: '3',
   D: '4',
   DN: '5',
};

export const changeResponseTransEnums = {
   A: '1',
   AC: '2',
   D: '3',
   V: '4',
};

export const renewalResponseEnums = {
   approve: 'A',
   approveWithChanges: 'AC',
   replace: 'R',
   decline: 'D',
   declineNewToFollow: 'DN',
};

export const rxStatusCode = {
   delivered: '010',
   tranmitted: '000',
   error: '-9009',
   inError: '-1',
};

export const transmissionActions = {
   cancelRx: 'cancelrx',
   newRx: 'newrx',
};

export const transRemark = {
   processing: 'CP',
   failed: 'CF',
   declined: 'CD',
   approved: 'CA',
   signingPending: 'SP',
};

export const changeReasonCode = {
   U: 'U',
   G: 'G',
   T: 'T',
   D: 'D',
   S: 'S',
   OS: 'OS',
   P: 'P',
};

export const subcodeActions = {
   NADEAN: 'F',
   DEA: 'C',
};

export const AllowedSubCode = ['C', 'F', 'G'];

export const controlledSubstance = ['2', '3', '4', '5'];

export const AlphanumericRegex = /^[a-z0-9_\s,'-.#_@]*$/i;
export const NameRegex = /^(?!.*\/\/)[A-Za-z][A-Za-z0-9_\s'-]*$/i;
export const AddressRegex = /^[a-z0-9_\s,'-.#_@]*$/i;
export const CityRegex = /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/;
export const NumericRegex = /^\d+$/;
export const EmailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
export const PasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*-])(?=.{8,})/;

const currentDate = new Date();
export const maxDate = `${currentDate.getFullYear() - 15}-${(currentDate.getMonth() + 1)
   .toString()
   .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;

export const RxActions = {
   'New Rx': ' 1000',
   'Change Request': '6000',
   'Change Response': '6500',
   'Cancel Request': '3000',
   'Refill Request': '5000',
   'Refill Response': '5500',
   'Cancel Response': '8000',
   'Status Message': '4000',
   VERIFY: '4010',
   ERROR: '9000',
};

export const ADMIN_PERMISSIONS = [
   {
      PermissionName: 'API_UGRP_OP_CREATE_USER',
      PermissionCode: '71000',
   },
   {
      PermissionName: 'API_UGRP_OP_CREATE_ROLE',
      PermissionCode: '71001',
   },
   {
      PermissionName: 'API_UGRP_OP_CREATE_GROUP',
      PermissionCode: '71002',
   },
   {
      PermissionName: 'API_UGRP_OP_CREATE_PERMISSION',
      PermissionCode: '71003',
   },
   {
      PermissionName: 'API_UGRP_OP_GET_USER_LIST',
      PermissionCode: '71101',
   },
   {
      PermissionName: 'API_UGRP_OP_GET_ROLE',
      PermissionCode: '71103',
   },
   {
      PermissionName: 'API_UGRP_OP_GET_ROLE_LIST',
      PermissionCode: '71104',
   },
   {
      PermissionName: 'API_UGRP_OP_GET_GROUP',
      PermissionCode: '71105',
   },
   {
      PermissionName: 'API_UGRP_OP_GET_GROUP_LIST',
      PermissionCode: '71106',
   },
   {
      PermissionName: 'API_UGRP_OP_GET_PERMISSION',
      PermissionCode: '71107',
   },
   {
      PermissionName: 'API_UGRP_OP_GET_PERMISSION_LIST',
      PermissionCode: '71108',
   },
   {
      PermissionName: 'API_UGRP_OP_GET_PROVIDER_LIST',
      PermissionCode: '71109',
   },
   {
      PermissionName: 'API_UGRP_OP_GET_USER_IN_GROUP',
      PermissionCode: '71110',
   },
   {
      PermissionName: 'API_UGRP_OP_UPDATE_ROLE',
      PermissionCode: '71201',
   },
   {
      PermissionName: 'API_UGRP_OP_UPDATE_GROUP',
      PermissionCode: '71202',
   },
   {
      PermissionName: 'API_UGRP_OP_UPDATE_PERMISSION',
      PermissionCode: '71203',
   },
   {
      PermissionName: 'API_UGRP_OP_DELETE_USER',
      PermissionCode: '71300',
   },
   {
      PermissionName: 'API_UGRP_OP_DELETE_ROLE',
      PermissionCode: '71301',
   },
   {
      PermissionName: 'API_UGRP_OP_DELETE_GROUP',
      PermissionCode: '71302',
   },
   {
      PermissionName: 'API_UGRP_OP_DELETE_PERMISSION',
      PermissionCode: '71303',
   },
   {
      PermissionName: 'API_UGRP_OP_MAP_USER_TO_ROLE',
      PermissionCode: '71400',
   },
   {
      PermissionName: 'API_UGRP_OP_CREATE_TEMP_PASSWORD',
      PermissionCode: '71403',
   },
   {
      PermissionName: 'API_UGRP_OP_PROCESS_GROUP_USERS',
      PermissionCode: '71405',
   },
   {
      PermissionName: 'API_UGRP_OP_ENROL_PROVIDER',
      PermissionCode: '71406',
   },
   {
      PermissionName: 'API_UGRP_OP_UPDATE_PROVIDER',
      PermissionCode: '71407',
   },
   {
      PermissionName: 'API_UGRP_OP_UPDATE_USER',
      PermissionCode: '71200',
   },
];

export const SYSTEM_PERMISSION = {
   API_UGRP_OP_CREATE_USER: {
      PermissionName: 'API_UGRP_OP_CREATE_USER',
      PermissionCode: '71000',
   },
   API_UGRP_OP_CREATE_ROLE: {
      PermissionName: 'API_UGRP_OP_CREATE_ROLE',
      PermissionCode: '71001',
   },
   API_UGRP_OP_CREATE_GROUP: {
      PermissionName: 'API_UGRP_OP_CREATE_GROUP',
      PermissionCode: '71002',
   },
   API_UGRP_OP_CREATE_PERMISSION: {
      PermissionName: 'API_UGRP_OP_CREATE_PERMISSION',
      PermissionCode: '71003',
   },
   API_UGRP_OP_GET_USER: {
      PermissionName: 'API_UGRP_OP_GET_USER',
      PermissionCode: '71100',
   },
   API_UGRP_OP_GET_USER_LIST: {
      PermissionName: 'API_UGRP_OP_GET_USER_LIST',
      PermissionCode: '71101',
   },
   API_UGRP_OP_GET_USER_ACCESS_LIST: {
      PermissionName: 'API_UGRP_OP_GET_USER_ACCESS_LIST',
      PermissionCode: '71102',
   },
   API_UGRP_OP_GET_ROLE: {
      PermissionName: 'API_UGRP_OP_GET_ROLE',
      PermissionCode: '71103',
   },
   API_UGRP_OP_GET_ROLE_LIST: {
      PermissionName: 'API_UGRP_OP_GET_ROLE_LIST',
      PermissionCode: '71104',
   },
   API_UGRP_OP_GET_GROUP: {
      PermissionName: 'API_UGRP_OP_GET_GROUP',
      PermissionCode: '71105',
   },
   API_UGRP_OP_GET_GROUP_LIST: {
      PermissionName: 'API_UGRP_OP_GET_GROUP_LIST',
      PermissionCode: '71106',
   },
   API_UGRP_OP_GET_PERMISSION: {
      PermissionName: 'API_UGRP_OP_GET_PERMISSION',
      PermissionCode: '71107',
   },
   API_UGRP_OP_GET_PERMISSION_LIST: {
      PermissionName: 'API_UGRP_OP_GET_PERMISSION_LIST',
      PermissionCode: '71108',
   },
   API_UGRP_OP_GET_PROVIDER_LIST: {
      PermissionName: 'API_UGRP_OP_GET_PROVIDER_LIST',
      PermissionCode: '71109',
   },
   API_UGRP_OP_GET_USER_IN_GROUP: {
      PermissionName: 'API_UGRP_OP_GET_USER_IN_GROUP',
      PermissionCode: '71110',
   },
   API_UGRP_OP_GET_APPROVAL_REQUEST: {
      PermissionName: 'API_UGRP_OP_GET_APPROVAL_REQUEST',
      PermissionCode: '71111',
   },
   API_UGRP_OP_GET_ACCEPTANCE_REQUEST: {
      PermissionName: 'API_UGRP_OP_GET_ACCEPTANCE_REQUEST',
      PermissionCode: '71112',
   },
   API_UGRP_OP_GET_APPROVAL_HISTORY: {
      PermissionName: 'API_UGRP_OP_GET_APPROVAL_HISTORY',
      PermissionCode: '71113',
   },
   API_UGRP_OP_GET_ACCEPTANCE_HISTORY: {
      PermissionName: 'API_UGRP_OP_GET_ACCEPTANCE_HISTORY',
      PermissionCode: '71114',
   },
   API_UGRP_LOAD_LOGGED_ACTIVITY: {
      PermissionName: 'API_UGRP_LOAD_LOGGED_ACTIVITY',
      PermissionCode: '71115',
   },
   API_UGRP_OP_UPDATE_USER: {
      PermissionName: 'API_UGRP_OP_UPDATE_USER',
      PermissionCode: '71200',
   },
   API_UGRP_OP_UPDATE_ROLE: {
      PermissionName: 'API_UGRP_OP_UPDATE_ROLE',
      PermissionCode: '71201',
   },
   API_UGRP_OP_UPDATE_GROUP: {
      PermissionName: 'API_UGRP_OP_UPDATE_GROUP',
      PermissionCode: '71202',
   },
   API_UGRP_OP_UPDATE_PERMISSION: {
      PermissionName: 'API_UGRP_OP_UPDATE_PERMISSION',
      PermissionCode: '71203',
   },
   API_UGRP_OP_DELETE_USER: {
      PermissionName: 'API_UGRP_OP_DELETE_USER',
      PermissionCode: '71300',
   },
   API_UGRP_OP_DELETE_ROLE: {
      PermissionName: 'API_UGRP_OP_DELETE_ROLE',
      PermissionCode: '71301',
   },
   API_UGRP_OP_DELETE_GROUP: {
      PermissionName: 'API_UGRP_OP_DELETE_GROUP',
      PermissionCode: '71302',
   },
   API_UGRP_OP_DELETE_PERMISSION: {
      PermissionName: 'API_UGRP_OP_DELETE_PERMISSION',
      PermissionCode: '71303',
   },
   API_UGRP_OP_MAP_USER_TO_ROLE: {
      PermissionName: 'API_UGRP_OP_MAP_USER_TO_ROLE',
      PermissionCode: '71400',
   },
   API_UGRP_OP_APPROVE_USER_MEMBERSHIP: {
      PermissionName: 'API_UGRP_OP_APPROVE_USER_MEMBERSHIP',
      PermissionCode: '71401',
   },
   API_UGRP_OP_ACCEPT_USER_MEMBERSHIP: {
      PermissionName: 'API_UGRP_OP_ACCEPT_USER_MEMBERSHIP',
      PermissionCode: '71402',
   },
   API_UGRP_OP_CREATE_TEMP_PASSWORD: {
      PermissionName: 'API_UGRP_OP_CREATE_TEMP_PASSWORD',
      PermissionCode: '71403',
   },
   API_UGRP_OP_RESET_PASSWORD: {
      PermissionName: 'API_UGRP_OP_RESET_PASSWORD',
      PermissionCode: '71404',
   },
   API_UGRP_OP_PROCESS_GROUP_USERS: {
      PermissionName: 'API_UGRP_OP_PROCESS_GROUP_USERS',
      PermissionCode: '71405',
   },
   API_UGRP_OP_ENROL_PROVIDER: {
      PermissionName: 'API_UGRP_OP_ENROL_PROVIDER',
      PermissionCode: '71406',
   },
   API_UGRP_OP_UPDATE_PROVIDER: {
      PermissionName: 'API_UGRP_OP_UPDATE_PROVIDER',
      PermissionCode: '71407',
   },
   API_UGRP_OP_ACCEPT_MEMBER: {
      PermissionName: 'API_UGRP_OP_ACCEPT_MEMBER',
      PermissionCode: '71408',
   },
   API_UGRP_OP_APPROVE_USERS_MEMBERSHIP: {
      PermissionName: 'API_UGRP_OP_APPROVE_USERS_MEMBERSHIP',
      PermissionCode: '71409',
   },
   API_ERX_REFILL_REQUEST_LIST: {
      PermissionName: 'API_ERX_REFILL_REQUEST_LIST',
      PermissionCode: '70001',
   },
   API_ERX_CHANGE_REQUEST_LIST: {
      PermissionName: 'API_ERX_CHANGE_REQUEST_LIST',
      PermissionCode: '70410',
   },
   API_ERX_REFILL_REQUEST_DETAIL: {
      PermissionName: 'API_ERX_REFILL_REQUEST_DETAIL',
      PermissionCode: '70413',
   },
   API_ERX_CHANGE_REQUEST_DETAIL: {
      PermissionName: 'API_ERX_CHANGE_REQUEST_DETAIL',
      PermissionCode: '70411',
   },
   API_ERX_RENEWAL_RESPONSE: {
      PermissionName: 'API_ERX_RENEWAL_RESPONSE',
      PermissionCode: '70405',
   },
   API_ERX_CHANGE_RESPONSE: {
      PermissionName: 'API_ERX_CHANGE_RESPONSE',
      PermissionCode: '70403',
   },
   API_ERX_EPCS_READY_TO_SIGN: {
      PermissionName: 'API_ERX_EPCS_READY_TO_SIGN',
      PermissionCode: '70406',
   },
   API_ERX_EPCS_SIGNING: {
      PermissionName: 'API_ERX_EPCS_SIGNING',
      PermissionCode: '70407',
   },
   API_ERX_NEWRX: {
      PermissionName: 'API_ERX_NEWRX',
      PermissionCode: '70401',
   },
   API_ERX_CANCELRX: {
      PermissionName: 'API_ERX_CANCELRX',
      PermissionCode: '70402',
   },
   API_ERX_CANCEL_REFREQ: {
      PermissionName: 'API_ERX_CANCEL_REFREQ',
      PermissionCode: '70419',
   },
   API_ERX_CANCEL_CHGREQ: {
      PermissionName: 'API_ERX_CANCEL_CHGREQ',
      PermissionCode: '70418',
   },
   API_ERX_UPDATE_LOOSE_CHANGERX_PATIENT: {
      PermissionName: 'API_ERX_UPDATE_LOOSE_CHANGERX_PATIENT',
      PermissionCode: '70414',
   },
   API_ERX_UPDATE_LOOSE_REFILL_PATIENT: {
      PermissionName: 'API_ERX_UPDATE_LOOSE_REFILL_PATIENT',
      PermissionCode: '70415',
   },
   API_PCO_UPDATE_RX_ORDER: {
      PermissionName: 'API_PCO_UPDATE_RX_ORDER',
      PermissionCode: '53203',
   },
   API_PCO_ADD_RX_ORDER: {
      PermissionName: 'API_PCO_ADD_RX_ORDER',
      PermissionCode: '53004',
   },
   API_PCO_ADD_MEDICATION: {
      PermissionName: 'API_PCO_ADD_MEDICATION',
      PermissionCode: '53003',
   },
   API_PCO_ADD_PHARMACY_TO_PATIENT: {
      PermissionName: 'API_PCO_ADD_PHARMACY_TO_PATIENT',
      PermissionCode: '53005',
   },
   API_PCO_UPDATE_MEDICATION: {
      PermissionName: 'API_PCO_UPDATE_MEDICATION',
      PermissionCode: '53202',
   },
   API_PCO_DELETE_MEDICATION: {
      PermissionName: 'API_PCO_DELETE_MEDICATION',
      PermissionCode: '53302',
   },
   API_PDM_OP_CREATE_PATIENT: {
      PermissionName: 'API_PDM_OP_CREATE_PATIENT',
      PermissionCode: '52001',
   },
   API_PDM_OP_GET_PATIENT_LIST: {
      PermissionName: 'API_PDM_OP_GET_PATIENT_LIST',
      PermissionCode: '52101',
   },
   API_PDM_OP_CREATE_PATIENT_VITAL_SIGNS: {
      PermissionName: 'API_PDM_OP_CREATE_PATIENT_VITAL_SIGNS',
      PermissionCode: '52004',
   },
   API_PDM_OP_UPDATE_PATIENT_VITAL_SIGNS: {
      PermissionName: 'API_PDM_OP_UPDATE_PATIENT_VITAL_SIGNS',
      PermissionCode: '52204',
   },
   API_PDM_OP_DELETE_PATIENT_VITAL_SIGNS: {
      PermissionName: 'API_PDM_OP_DELETE_PATIENT_VITAL_SIGNS',
      PermissionCode: '52302',
   },
   API_PDM_OP_GET_PATIENT_LIST_VITAL_SIGNS: {
      PermissionName: 'API_PDM_OP_GET_PATIENT_LIST_VITAL_SIGNS',
      PermissionCode: '52108',
   },
   API_PCO_GET_MEDICATION_LIST: {
      PermissionName: 'API_PCO_GET_MEDICATION_LIST',
      PermissionCode: '53106',
   },
   API_ERX_MULTIPLE_NEWRX: {
      PermissionName: 'API_ERX_MULTIPLE_NEWRX',
      PermissionCode: '70420',
   },
   API_PCO_GET_RX_ORDER_LIST: {
      PermissionName: 'API_PCO_GET_RX_ORDER_LIST',
      PermissionCode: '53108',
   },
   API_PCO_GET_PROVIDER_MEDICATION: {
      PermissionName: 'API_PCO_GET_PROVIDER_MEDICATION',
      PermissionCode: '53120',
   },
};
